import React, { Fragment } from "react";
// import { Media } from "react-breakpoints";
import { useBreakpoints } from "../hooks";

const FilterableScreen = (props) => {
   // eslint-disable-next-line no-unused-vars
   const { isMobile, isDesktop } = useBreakpoints();
   
   return (
      <Fragment>
         {isMobile ? (
            <Fragment>
               <div className="mobileWithFilterFooter">{props.children}</div>
               <div className="mobileFilterFooter">{props.filters}</div>
            </Fragment>
         ) : (
            <div className="filterableScreen">
               {props.filters &&
                  <div className="filterPagerHeader">{props.filters}</div>
               }
               <div className="contentWithFilters">{props.children}</div>
               {props.pager &&
                  <div className="pagerFooter">{props.pager}</div>
               }
            </div>
         )}
      </Fragment>
   )
};

export default FilterableScreen;